import axios from 'axios';
import Cookies from 'js-cookie'
import { ElNotification } from 'element-plus'
import router from '@/router';


const instance = axios.create({
	// baseURL: 'http://127.0.0.1:8198'
	//baseURL: 'http://43.139.165.79:30189'
	//baseURL: 'http://192.168.31.102:30189'
	// baseURL:'http://112.6.224.25:31897'
	baseURL: 'http://111.35.64.52:30189'
});

instance.interceptors.request.use(
	(config) => {
		const token = Cookies.get('token');

		if (token) {
			config.headers.Authorization = `${token}`;
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

instance.interceptors.response.use(
	(response) => {
		if (response.data.code == '66') {
			ElNotification({
				title: '访问失败',
				message: '登录令牌失效，请重新登录',
				type: 'error'
			});
			// Use the imported router instance to push to the login view
			router.push({ name: 'loginview' });
		} else if (response.data.code != '0') {
			ElNotification({
				title: '提示',
				message: response.data.msg,
				type: 'error'
			});
		} 
		return response.data
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default instance;
